(function ($) {
  var FilterableGridMenu = function ($menu, options) {
    options = options || {};

    this.$menu = $menu;
    this.$filters = $('[data-filter-tag]', $menu);
    this.$groupButtons = $('.js-group-toggle[data-filter-group]', $menu);

    this.catchAllFilterGroupKeys = {};

    this.processDom();
    this.setupDomEvents();

    this.$groupButtons.first().trigger('click');
    // Add class to trigger normal css.
    $menu.addClass('js-loaded');
  };

  /*
   * Process the domto get settings.
   */
  FilterableGridMenu.prototype.processDom = function () {
    var $menu = this.menu;
    // Get a list of all the filter keys that are catch-all (do not filter);
    var $catchAllFilterGroups = $('[data-filter-group][data-always-match="1"]', $menu);
    var catchAllFilterGroupKeys = {};

    $catchAllFilterGroups.each(function (i, obj) {
      var $filterGroup = $(obj);
      var filterGroup = $filterGroup.data('filter-group');

      catchAllFilterGroupKeys[filterGroup] = true;
    });
    this.catchAllFilterGroupKeys = catchAllFilterGroupKeys;
  };

  /*
   * Setup dom events.
   */
  FilterableGridMenu.prototype.setupDomEvents = function () {
    var self = this;

    this.$groupButtons.on('click', function (e) {
      var $filterGroup = $(this);

      self.handleGroupButtonClick(e, $filterGroup);
    });

    this.$filters.on('click', function (e) {
      var $filter = $(this);

      self.handleFilterClick(e, $filter);
    });
  };

  /*
   * Handle filter click. This will handle the filter UX and then emit a
   * filterState event.
   */
  FilterableGridMenu.prototype.handleFilterClick = function (e, $filter) {
    var self = this;
    var currentlyActive = $filter.hasClass('active');
    var setActive = !currentlyActive;
    var $filterGroup = $filter.closest('[data-filter-group]');
    var maxCount = $filterGroup.data('max');
    var $activeGroupFilters = $filterGroup.find('[data-filter-tag].active');

    // Handle the maxCount. Leave enough room to setting $filter to active
    // won't go over maxCount;
    if (setActive && typeof maxCount !== 'undefined' && $activeGroupFilters.length >= maxCount) {
      $activeGroupFilters.each(function (i, obj) {
        if (i >= maxCount - 1) {
          self.setFilterActiveStatus($(obj), false);
        }
      });
    }

    // Now flip $filter off/on.
    self.setFilterActiveStatus($filter, setActive);

    var filterState = this.getFilterState();

    this.$menu.trigger('filterable-grid-menu:filterStateChange', [filterState]);
  };

  /*
   * Helper function for setting active since we also set the parent.
   */
  FilterableGridMenu.prototype.setFilterActiveStatus = function ($filter, setActive) {
    if (setActive) {
      $filter.addClass('active');
      $filter.parent().addClass('active');
    } else {
      $filter.removeClass('active');
      $filter.parent().removeClass('active');
    }
  };

  /*
   * Go through menu dom and generate the filterState which includes a
   * filerQuery compatible with MantleGrid.Filter and a stateFlags object which
   * is largely a flattened filterQuery + some extra state flags.
   *
   * wasFiltered: flag whether items were removed. Some filter tags do not
   * actually change the result list. They just change how the result items
   * look.
   *
   * _empty: flag for the base state with nothing selected. This is often used
   * for initial load state.
   */
  FilterableGridMenu.prototype.getFilterState = function () {
    var catchAllFilterGroupKeys = this.catchAllFilterGroupKeys;
    var filterQuery = {
      __type: 'AND'
    };
    // Flat collection of all filter flags.
    var stateFlags = {};
    var wasFiltered = false;
    var $activeFilters = this.$filters.filter('.active');

    $activeFilters.each(function (i, obj) {
      var $filter = $(obj);
      var filter_key = $filter.data('filter-tag');
      var $filterGroup = $filter.closest('[data-filter-group]');
      var filterGroup = 'default';

      if ($filterGroup.length > 0) {
        filterGroup = $filterGroup.data('filter-group');
      }

      // stateFlags get set even if filter is match-all
      stateFlags[filter_key] = true;
      // do not filter by match all keys
      if (catchAllFilterGroupKeys[filterGroup]) {
        return;
      }

      if (typeof filterQuery[filterGroup] === 'undefined') {
        filterQuery[filterGroup] = {};
      }

      wasFiltered = true;
      filterQuery[filterGroup][filter_key] = true;
    });

    if (_.isEmpty(stateFlags)) {
      // Set an empty sentinel to make it easier on state change handlers
      stateFlags._empty = true;
    }

    stateFlags.filtered = wasFiltered;

    var filterState = {
      stateFlags: stateFlags,
      filterQuery: filterQuery
    };

    return filterState;
  };

  /*
   * Handle Group toggle clicks.
   *
   * This is currently for mobile menus though the classes are set regardless
   * of breakpoint. This sets an active filter group, even though on mobile we
   * don't hide/show the groups.
   */
  FilterableGridMenu.prototype.handleGroupButtonClick = function (e, $filterGroup) {
    var $menu = this.$menu;
    var filterGroupKey = $filterGroup.data('filter-group');
    var $allTags = $menu.find('.js-filterable-grid-menu__category');
    var $tags = $allTags.filter('[data-filter-group="' + filterGroupKey + '"]');

    $allTags.removeClass('active');
    $tags.addClass('active');
    this.$groupButtons.removeClass('active');
    $filterGroup.addClass('active');
  };

  Drupal.behaviors.filterableGridMenuV1 = {
    attach: function (context) {
      var $menus = $('.js-filterable-grid-menu', context);

      $menus.each(function (i, obj) {
        var $menu = $(obj);
        var menuManager = new FilterableGridMenu($menu);

        $menu.data('menu-manager', menuManager);
      });
    }
  };
})(jQuery);
